<template>
  <b-modal
    id="kp-percentage-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('objects.download_kp')"
    :title="$t('Выберите процент')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    @ok.prevent="saveData"
  >
    <b-row>
      <b-col md="6">
        <div
          v-for="(percentage, index) in firstColumnPercentages"
          :key="'first-' + index"
          class="mb-50"
        >
          <b-form-radio
            class="custom-control-success"
            v-model="payment_in_percent"
            name="percentages"
            :value="percentage.id"
          >
            {{ percentage.value }}<b>%</b>
          </b-form-radio>
        </div>
      </b-col>
      <b-col md="6">
        <div
          v-for="(percentage, index) in secondColumnPercentages"
          :key="'second-' + index"
          class="mb-50"
        >
          <b-form-radio
            class="custom-control-success"
            v-model="payment_in_percent"
            name="percentages"
            :value="percentage.id"
          >
            {{ percentage.value }}<b>%</b>
          </b-form-radio>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol, BFormRadio } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormRadio,
  },

  data() {
    return {
      payment_in_percent: "",
    };
  },

  computed: {
    ...mapGetters("flats", ["GET_FLAT_PERCENTAGES"]),

    firstColumnPercentages() {
      const half = Math.ceil(this.GET_FLAT_PERCENTAGES.length / 2);
      return this.GET_FLAT_PERCENTAGES.slice(0, half);
    },
    secondColumnPercentages() {
      const half = Math.ceil(this.GET_FLAT_PERCENTAGES.length / 2);
      return this.GET_FLAT_PERCENTAGES.slice(half);
    },
  },

  methods: {
    ...mapActions("flats", ["FETCH_FLAT_PERCENTAGES"]),

    saveData() {
      if (!this.payment_in_percent) return;
      this.$emit("percentageSelected", this.payment_in_percent);
    },
  },

  mounted() {
    this.FETCH_FLAT_PERCENTAGES();
  },
};
</script>
